module.exports = __webpack_public_path__ + "img/shedBg1.17754874.png";